import { CustomValidationError } from '../style'
import { RichTextEditorWrapper, Note, StyledQuillEditor } from './style'

type TRichTextEditorProps = {
  value: string | undefined
  errorMessage?: string
  placeholder?: string
  handleChange: (field: string, value: any) => void
  handleBlur: (e: any) => void
  name: string
  isDisabled?: boolean
  fieldTouched?: boolean
  maxHeight?: string
  minHeight?: string
  setTouched?: (touched: any, shouldValidate?: boolean) => void
  setFieldTouched?: (field: string) => void
  showCharacterCount?: boolean
  maxLength?: number
  borderRadius?: string
  borderColor?: string
}

const RichTextEditor = ({
  value = '',
  fieldTouched = false,
  placeholder,
  errorMessage = '',
  isDisabled = false,
  minHeight = '100px',
  maxHeight = '200px',
  handleBlur,
  handleChange,
  name,
  setTouched,
  setFieldTouched,
  maxLength,
  showCharacterCount = false,
  borderRadius,
  borderColor,
}: TRichTextEditorProps) => {
  return (
    <RichTextEditorWrapper
      maxHeight={maxHeight}
      minHeight={minHeight}
      {...(borderRadius && { borderRadius })}
    >
      <StyledQuillEditor
        value={value}
        {...(borderRadius && { borderRadius })}
        {...(borderColor && { borderColor })}
        onChange={(content, quill, source) => {
          // If the editor is empty, the content string still has some empty HTML (<p><br/></p>).
          // This introduces issues when we try to validate the field.
          // getText() method returns the pure string only (which can consist of empty spaces only too), without any markup.
          // Only handle changes when the source of the change is the user. The source can be "api", which triggers on mount and produces slightly different html, causing forms to be dirty from the go.
          if (source === 'user')
            if (quill.getText().trim().length) {
              handleChange(name, content)
            } else {
              handleChange(name, '')
            }
        }}
        placeholder={placeholder}
        {...(errorMessage && fieldTouched && { className: 'rich_text_editor__hasError' })}
        {...(isDisabled && { className: 'rich_text_editor__isDisabled' })}
        onBlur={(quill) => {
          handleBlur(quill.root.innerHTML)
          setTouched && setTouched({ [name]: true }, true)
          setFieldTouched && setFieldTouched(name)
        }}
        readOnly={isDisabled}
        toolbarOptions={[
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ]}
      />
      {/* Implementation from TextArea in Friday UI */}
      {(() => {
        if (maxLength) {
          if (showCharacterCount && value) {
            return <Note>{`${value.length} characters out of ${maxLength} allowed.`}</Note>
          } else {
            return <Note>{`Maximum ${maxLength} characters allowed.`}</Note>
          }
        } else {
          return value && showCharacterCount && <Note>{`${value.length} characters.`}</Note>
        }
      })()}

      {errorMessage && fieldTouched ? (
        <CustomValidationError>{errorMessage}</CustomValidationError>
      ) : null}
    </RichTextEditorWrapper>
  )
}

export default RichTextEditor
